export const isMobile = () => window.innerWidth < 768;

export const isIE = () => {
  return navigator.userAgent.toLowerCase().indexOf("msie") > 0;
};

export const isIEorEdge = () => {
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
};

export const isFirefox = () => {
  return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
};

export const write = (el, value) => {
  el.innerHTML = value;
};

export const set = (item, selector) => {
  if (item instanceof Array) {
    for (let i of item) {
      i.classList.add(selector);
    }
  } else {
    if (item) {
      item.classList.add(selector);
    }
  }
};

export const unset = (item, selector) => {
  if (item instanceof Array) {
    for (let i of item) {
      i.classList.remove(selector);
    }
  } else {
    if (item) {
      item.classList.remove(selector);
    }
  }
};

export const contains = (item, selector) => {
  if (!item) {
    return false;
  }

  return item.classList.contains(selector);
};

export const toggle = (item, selector) => {
  if (item instanceof Array) {
    for (let i of item) {
      i.classList.toggle(selector);
    }
  } else {
    if (item) {
      item.classList.toggle(selector);
    }
  }
};

export const getHeight = (el: HTMLElement) => {
  return `${el.offsetHeight}px`;
};

export const getWidth = (el: HTMLElement) => {
  return `${el.offsetWidth}px`;
};

export const isOver = (breakpoint: number) => {
  return window.innerWidth > breakpoint;
};

export const formatPrice = (
  num,
  locale = "en-EN",
  currency = "USD",
  fractionDigits = 2
) => {
  return (Number(num) / 100).toLocaleString(locale, {
    style: "currency",
    currency: currency,
    currencyDisplay: "symbol",
    maximumFractionDigits: fractionDigits,
  });
};

export const getUrlParam = (name) => {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]"); // eslint-disable-line
  let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  let results = regex.exec(window.location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const handleize = (str: string) => str.replace(/[ /_]/g, "-").toLowerCase() as string;

/**
 * Decodes a string that has been encode through the 'url_encode' Shopify filter
 * @param {*} str
 */
export const decode = (str: string) => decodeURIComponent(str).replace(/\+/g, " ") as string;

/**
 * Generates a URL that is suitable for the Shopify
 * image CDN. Adds the current image size suffix.
 *
 * @param {*} src
 * @param {*} size
 */
export const getImageWithSize = (
  src: string = "",
  size: number = 1000
): string => {
  return ("" + src).replace(/([.](?:jpe?g|png))/, `_${size}x$1`);
};

/**
 * Used by components like the product card to select
 * the current product image based on the active color.
 * If there is no active color, a fallback image
 * should be returned if it is defined.
 *
 * @param {*} color
 * @param {*} images
 * @param {*} featured
 * @param {*} fallback
 */
export const getProductImage = (
  name = "",
  value = "",
  images,
  featured = false,
  fallback = false
) => {
  const key = `${name}-${(value || "").replace(/[/ ]/g, "-")}`.toLowerCase();
  const image = (images || []).find((i) => {
    return ~i.indexOf(key) && ~i.indexOf(featured ? "pos-1" : "pos-2");
  });
  if (!image) {
    return getImageWithSize(fallback, 600);
  }
  return getImageWithSize(image, featured ? 1200 : 600);
};

export const createArrayFromNumRange = (size, start) => {
  return Array.from(Array(size), (_, i) => start + i);
};

export const createMonthArray = () => {
  return [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
};
